import { AiOutlineLink } from "react-icons/ai";
const ProjectCard = ({ img, url, description }) => {
  const handleClick = () => {
    window.open(url);
  };
  return (
    <div className="portfolio-item" onClick={handleClick}>
      <div className="portfolio-wrap">
        <img src={`data:image/png;base64, ${img}`} alt="portfolioImg" />
        <div className="portfolio-links">
          <p className="project-short-description">{description}</p>
          <p>
            <button onClick={handleClick}>
              <AiOutlineLink />
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};
export default ProjectCard;
